import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "subscription-inactive-banner",
  role: "alert"
}
const _hoisted_2 = { class: "subscription-inactive-banner__content" }
const _hoisted_3 = { class: "subscription-inactive-banner__message" }

import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { Icon } from "@iconify/vue";
import { useBillingStatus } from "@/composables/billing/useBillingStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionInactiveBanner',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const { usageBlockedState } = useBillingStatus();

const isOnBillingPage = computed(() => route.path.startsWith("/settings/billing"));

const hasErrorPersistentBanner = computed(() => store.getters.persistentBanner?.type === "error");

const shouldShow = computed(
  () => usageBlockedState.value.blocked && !isOnBillingPage.value && !hasErrorPersistentBanner.value
);

const message = computed(() => {
  const reason = usageBlockedState.value.reason;
  if (reason === "past_due" || reason === "unpaid") {
    return "Your last payment failed. Update your payment method to keep using calls, SMS, and AI features.";
  }
  if (reason === "canceled") {
    return "Your subscription has been canceled. Reactivate to continue using paid features.";
  }
  if (reason === "incomplete" || reason === "incomplete_expired") {
    return "Your subscription setup is incomplete. Complete it to use paid features.";
  }
  return "Your subscription is inactive. Update your billing to continue using paid features.";
});

const ctaLabel = computed(() => {
  const reason = usageBlockedState.value.reason;
  if (reason === "past_due" || reason === "unpaid") return "Update payment method";
  if (reason === "canceled") return "Reactivate";
  if (reason === "incomplete" || reason === "incomplete_expired") return "Complete setup";
  return "Go to billing";
});

const handleCTAClick = () => {
  router.push({ path: "/settings/billing" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "banner" }, {
    default: _withCtx(() => [
      (shouldShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Icon), {
                icon: "mdi:alert-circle-outline",
                class: "subscription-inactive-banner__icon"
              }),
              _createElementVNode("span", _hoisted_3, _toDisplayString(message.value), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "subscription-inactive-banner__cta",
              onClick: handleCTAClick
            }, _toDisplayString(ctaLabel.value), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})